var impressum = "Impressum";
var privacy = "Privacy & Wettelijk";
var recallInfo = "Informatie over terugroepacties";
var signOut = "Afmelden";
var nl_nl = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { nl_nl as default, impressum, privacy, recallInfo, signOut };
